function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 57,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h57v57H0z",
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: 2
    },
    transform: "translate(.304 .304)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    },
    transform: "translate(-.304 -.304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.804-.521v58.65M-.521 28.804h58.65",
    style: {
      stroke: "white",
      strokeWidth: 2,
      fill: "none",
      strokeMiterlimit: 10
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.723c62ac31adcfc560746eac533b3700.svg";
export { ForwardRef as ReactComponent };